<div fxFill fxLayout="column">
  <app-opening-hour-calendar-edit #calendarEdit [editingItem]="calendar" [showSideSteps]="false"></app-opening-hour-calendar-edit>
</div>
